export enum StorageKeys {
  FUNDING_WALLET_DETAILS = "fundingwalletdetails",
}
